module.exports = __webpack_public_path__ + "img/stock3.b764135a.png";